module.exports = __webpack_public_path__ + "img/equipment.14c4491f.png";